import { BookIcon, DeviceMobileIcon, HomeIcon, KebabHorizontalIcon, MailIcon, NoteIcon, NumberIcon, PencilIcon, PersonIcon, PlusIcon, SyncIcon, TrashIcon } from "@primer/octicons-react";
import { ActionList, ActionMenu, Box, Checkbox, useConfirm } from "@primer/react";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../components/ui/button";
import DataTable from "../../../../components/ui/data-table";
import Text from "../../../../components/ui/text";
import { useCommonContext } from "../../../../contexts/common";
import { useCommonSelectedHook } from "../../../../hooks/useCommonSelectedHook";
import { ePageBaseStatus } from "../../../../models/ePageBaseStatus";
import { IConCbnv, IConCbnvVm } from "../../../../models/response/hoc-sinh/IConCbnv";
import { actions } from "../../../../state/actions/actionsWrapper";
import { RootState } from "../../../../state/reducers";
import { HocSinh } from "../../gia-dinh/QuanHeGiaDinhHocSinh";
import ConEmGiaoVienEditModal from "./ConEmGiaoVienEditModal";
interface Props {
    hocSinh: HocSinh;
    canEdit?: boolean;
}
const ConEmGiaoVienPage: React.FC<Props> = ({ hocSinh, canEdit = true }) => {
    const { status, conCbnvs, isShowEditModal, editingData } = useSelector((x: RootState) => x.conCbnv)
    const { nam_hoc, dm_coso_id } = useCommonSelectedHook();
    const { translate } = useCommonContext();
    const confirm = useConfirm();
    const dispatch = useDispatch();
    useEffect(() => {
        if (status === ePageBaseStatus.is_not_initialization || status === ePageBaseStatus.is_need_reload) {
            handleReload();
        }
    }, [status])
    const handleReload = () => {
        dispatch(actions.conCbnv.LOAD_START({ ts_hocsinh_id: hocSinh.id, nam_hoc: nam_hoc }))
    }
    const handleDelete = async (id: number) => {
        if (await confirm({
            content: translate("Base.Label.DeleteConfirm.Content"),
            title: translate("Base.Label.Confirm"),
            cancelButtonContent: translate("Base.Label.Close"),
            confirmButtonContent: translate("Base.Label.Delete"),
            confirmButtonType: "danger"
        })) {
            dispatch(actions.conCbnv.DELETE_START(id))
        }
    }
    const dataSource = useMemo(() => {
        return conCbnvs.filter(x => x.nam_hoc == nam_hoc)
    }, [conCbnvs])

    return (
        <Box>
            <DataTable
                data={dataSource}
                isLoading={status === ePageBaseStatus.is_loading}
                title={translate("Con em giáo viên")}
                searchEnable
                emptyComponent={
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", color: "fg.muted" }}>
                        Không có dữ liệu
                    </Box>
                }
                actionComponent={
                    <Box sx={{
                        display: "flex"
                    }}>
                        {canEdit && (
                            <Button text="Gán con em CBNV" leadingVisual={PlusIcon}
                                size="medium"
                                variant="primary"
                                onClick={() => {
                                    dispatch(actions.conCbnv.SHOW_EDIT_MODAL(undefined))
                                }}
                            />
                        )}
                        <Button text="Base.Label.Refresh" leadingVisual={SyncIcon}
                            size="medium"
                            sx={{ ml: canEdit ? 1 : 0 }}
                            onClick={() => {
                                handleReload();
                            }}
                        />
                    </Box>
                }
                columns={[
                    {
                        id: "cmd",
                        caption: "#",
                        width: "50px",
                        align: "center",
                        cellRender: (data: IConCbnv) => {
                            return canEdit ? (
                                <ActionMenu>
                                    <ActionMenu.Button icon={KebabHorizontalIcon} variant="invisible" sx={{ m: -1 }}>&nbsp;</ActionMenu.Button>
                                    <ActionMenu.Overlay width="auto">
                                        <ActionList>
                                            <ActionList.Item onSelect={() => {
                                                dispatch(actions.conCbnv.SHOW_EDIT_MODAL(data))
                                            }}>
                                                <ActionList.LeadingVisual><PencilIcon /></ActionList.LeadingVisual>
                                                <Text text='Base.Label.Edit' />
                                            </ActionList.Item>
                                            <ActionList.Item variant="danger" onSelect={() => {
                                                handleDelete(data.id)
                                            }}>
                                                <ActionList.LeadingVisual><TrashIcon /></ActionList.LeadingVisual>
                                                <Text text='Base.Label.Delete' />
                                            </ActionList.Item>
                                        </ActionList>
                                    </ActionMenu.Overlay>
                                </ActionMenu>
                            ) : <div></div>;
                        }
                    },
                    {
                        dataField: "ma_nhan_vien",
                        caption: translate("Mã nhân viên"),
                        cellRender: (data: IConCbnvVm) => {
                            return (

                                <Box style={{ display: "flex", alignItems: "center" }}>
                                    <Box style={{ color: "#133E87" }}>
                                        <NoteIcon size={14} />
                                    </Box>
                                    <span style={{ marginLeft: "5px" }}>
                                        {data.ma_nhan_vien}
                                    </span>
                                </Box>
                            );
                        },
                    },
                    {
                        dataField: "ten_nhan_vien",
                        caption: translate("Tên nhân viên"),
                        cellRender: (data: IConCbnvVm) => {

                            return (

                                <Box style={{ display: "flex", alignItems: "center" }}>
                                    <Box style={{ color: "#133E87" }}>
                                        <PersonIcon size={14} />
                                    </Box>
                                    <span style={{ marginLeft: "5px" }}>
                                        {data.ten_nhan_vien}
                                    </span>
                                </Box>
                            );
                        },
                    },
                    {
                        dataField: "phone_number",
                        caption: translate("Thông tin liên hệ"),
                        cellRender: (data: IConCbnvVm) => {
                            return (
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                        }}
                                    >
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <div style={{ color: "#133E87" }}>
                                                <DeviceMobileIcon size={14} />
                                            </div>
                                            <span style={{ marginLeft: "5px" }}>
                                                {data.phone_number}
                                            </span>
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <div style={{ color: "#133E87" }}>
                                                <MailIcon size={14} />
                                            </div>{" "}
                                            <span style={{ marginLeft: "5px" }}>
                                                {data.email || "..."}
                                            </span>
                                        </div>
                                    </Box>
                                </Box>
                            );
                        },
                    },
                    {
                        dataField: "capquanly_cbnv",
                        caption: translate("Tổ khối"),
                        cellRender: (data: IConCbnvVm) => {
                            return (

                                <Box style={{ display: "flex", alignItems: "center" }}>
                                    <Box style={{ color: "#133E87" }}>
                                        <BookIcon size={14} />
                                    </Box>
                                    <span style={{ marginLeft: "5px" }}>
                                        {data.capquanly_cbnv}
                                    </span>
                                </Box>
                            );
                        },
                    },
                    {
                        dataField: "quanhe_cbnv",
                        caption: translate("Quan hệ"),
                        cellRender: (data: IConCbnvVm) => {
                            return (

                                <Box style={{ display: "flex", alignItems: "center" }}>
                                    <Box style={{ color: "#133E87" }}>
                                        <HomeIcon size={14} />
                                    </Box>
                                    <span style={{ marginLeft: "5px" }}>
                                        {data.quanhe_cbnv}
                                    </span>
                                </Box>
                            );
                        },
                    },
                    {
                        dataField: "is_huonguudai",
                        width: 120,
                        caption: translate("Hưởng ưu đãi"),
                        cellRender: (data: IConCbnv) => {
                            return (
                                <Box sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}>
                                    <Checkbox checked={data.is_huonguudai} />
                                </Box>
                            )
                        }
                    },
                    {
                        dataField: "hinh_thuc_mien_giam",
                        caption: translate("Thông tin ưu đãi"),
                        cellRender: (data: IConCbnvVm) => {
                            return (

                                <Box style={{ display: "flex", alignItems: "center" }}>
                                    <Box style={{ color: "#133E87" }}>
                                        <NumberIcon size={14} />
                                    </Box>
                                    <span style={{ marginLeft: "5px" }}>
                                        {data.hinh_thuc_mien_giam}
                                    </span>
                                </Box>
                            );
                        },
                    },

                ]}
            />
            {isShowEditModal &&
                <ConEmGiaoVienEditModal hocSinh={hocSinh} />
            }
        </Box>
    );
};

export default ConEmGiaoVienPage;